import { SyncActionFactory } from '../../../shared/utils/redux/sync.actions'
import { WsEvents } from '../../../shared/ws/webSocket.type'

export class WsEventsActions {
  public static handleEvent = new SyncActionFactory<WsEvents>(
    '[WS EVENTS] HANDLE EVENT',
  )
}
